// ABOUTME: Centralized app branding constants.
// ABOUTME: Change the app name here and it updates everywhere.

export const APP_NAME = "Start";
export const APP_AUTHOR = "Brizzly";
export const APP_TAGLINE = `by ${APP_AUTHOR}`;
